import { apiClient } from './api';
import { ApiResponse } from '@/types';

export interface UploadResponse {
  url: string;
  filename?: string;
  id?: string;
}

export interface BatchUploadResponse {
  results: Array<{
    id: string;
    filename: string;
    mimeType: string;
    size: number;
    url: string;
    status: string;
  }>;
  failed: Array<{
    id: string;
    filename: string;
    error: string;
  }>;
}

export const uploadsApi = {
  async uploadFile(file: File): Promise<ApiResponse<UploadResponse>> {
    const formData = new FormData();
    formData.append('file', file);
    return apiClient.upload<UploadResponse>('/uploads/', formData);
  },

  async uploadFiles(files: File[]): Promise<ApiResponse<BatchUploadResponse>> {
    const formData = new FormData();
    files.forEach(file => {
      formData.append('files', file);
    });
    return apiClient.upload<BatchUploadResponse>('/uploads/batch/', formData);
  },
};
